import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import "./header.scss";
import HeaderNavItem from "./HeaderNavItem";
import { everestlogoHeader } from "../../source";
import { homeURL, winnersURL } from "../../helpers/paths";
const body = document.querySelector("body");

const navLinksArr = [
  {
    id: 1,
    type: "img",
    logo: everestlogoHeader,
    mainLink: homeURL,
    class: "logo_img",
  },
  {
    id: 2,
    type: "text",
    mainLink: `${homeURL}#program_rules`,
    mainTitle: "Program Rules",
  },
  {
    id: 3,
    type: "text",
    mainLink: `${homeURL}#gratification`,
    mainTitle: "Gratification",
  },
  {
    id: 4,
    type: "text",
    mainLink: `${homeURL}#register_process`,
    mainTitle: "Registration Process",
  },
  {
    id: 5,
    type: "text",
    mainLink: winnersURL,
    mainTitle: "Winners",
  },
  {
    id: 6,
    type: "text",
    mainLink: `${homeURL}#register`,
    mainTitle: "REGISTER NOW",
    class: "reg_cta",
  },
];

const mobNavLinksArr = [
  {
    id: 1,
    type: "text",
    mainLink: `${homeURL}#program_rules`,
    mainTitle: "Program Rules",
  },
  {
    id: 2,
    type: "text",
    mainLink: `${homeURL}#gratification`,
    mainTitle: "Gratification",
  },
  {
    id: 3,
    type: "text",
    mainLink: `${homeURL}#register_process`,
    mainTitle: "Registration Process",
  },
  {
    id: 4,
    type: "text",
    mainLink: winnersURL,
    mainTitle: "Winners",
  },
];

const Header = () => {
  const [navlinkIndex, setNavlinkIndex] = useState(null);
  const { width } = useWindowDimensions();
  const { pathname: locationPathname } = useLocation();
  const [isMenuActive, setIsMenuActive] = useState(false);

  useEffect(() => {
    body.style.overflow = "auto";
    setIsMenuActive(false);
  }, [locationPathname]);

  useEffect(() => {
    // Check if URL contains a hash
    if (window.location.hash) {
      // document.body.style.overflow = "auto";
      setIsMenuActive(false);
      // console.log("hash", window.location.hash);
    }
  }, [window.location.hash]);

  const scrollHandler = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const handleHamburgerClick = () => {
    setIsMenuActive(!isMenuActive);
    if (!isMenuActive) {
      body.style.overflow = "hidden";
    } else {
      body.style.overflow = "auto";
    }
  };

  const navlinkList = navLinksArr.map((nav, i) => (
    <>
      <li key={navLinksArr[i].id}>
        {nav.type === "text" ? (
          <div
            onClick={() => setNavlinkIndex(i)}
            className={`nav_tab ${nav.class}`}
            // data-aos="fade-down"
            // data-aos-delay={`${150 * i}`}
          >
            <a href={`${nav.mainLink}`} className="anchor">
              {nav.mainTitle}
            </a>
          </div>
        ) : (
          <div
            onClick={() => setNavlinkIndex(i)}
            className={`logo_wrapper ${navlinkIndex === i ? "" : ""} `}
            // data-aos="fade-down"
          >
            <a href={homeURL}>
              <img
                className={nav.class}
                onClick={scrollHandler}
                src={nav.logo}
                alt="everest"
              />
            </a>
          </div>
        )}
      </li>
    </>
  ));

  useEffect(() => {
    if (isMenuActive) {
      body.style.overflow = "hidden";
    } else {
      body.style.overflow = "auto";
    }
  }, []);

  return (
    <>
      <header className={`header_sec`}>
        {width > 1080 ? (
          <>
            <div className="my_container">
              <div className="navlinks">
                <ul>{navlinkList}</ul>
              </div>
            </div>
          </>
        ) : (
          <>
            <header className="header">
              <div className="my_container">
                <div className="logo_wrapper">
                  <div className="logo_link anchor">
                    <Link to={homeURL}>
                      <img
                        className="logo"
                        src={everestlogoHeader}
                        alt="everest logo"
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <nav className="nav_links_wrapper">
                <div
                  className={`nav_line2_wrapper_flex_wrapper ${
                    isMenuActive ? "active" : ""
                  }`}
                >
                  <div className="logo_wrapper">
                    <div className="logo_link anchor">
                      <img
                        className="logo"
                        src={everestlogoHeader}
                        alt="everest logo"
                      />
                    </div>
                  </div>
                  <ul className="nav_line2_wrapper_flex">
                    {mobNavLinksArr.map((navData, i) => (
                      <HeaderNavItem
                        navData={navData}
                        key={i}
                        setActiveIndex={() => {
                          setIsMenuActive(false);
                          handleHamburgerClick();
                        }}
                      />
                    ))}
                  </ul>
                </div>
              </nav>

              {/* mobile UI start */}
              <div
                className={`hamburger_lines black ${
                  isMenuActive ? "active" : ""
                }`}
                onClick={handleHamburgerClick}
              >
                <div className="line line1"></div>
                <div className="line line2"></div>
                <div className="line line3"></div>
              </div>
            </header>
          </>
        )}
      </header>
    </>
  );
};

export default Header;
